module.exports = __webpack_public_path__ + "static/bicycle-d639ad4f8ad85cf0786ef306584747a7.svg";